import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { getFeatureFlag } from '../helpers/shell-helpers'
import { UnleashFlags } from '../models/feature-flag.models'
import { createMsTeamsIntegrationConfigIfFlagEnabled } from '../helpers/ms-teams-integration-helpers'

const integrationFlagSuffix = 'oos-training'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-training-app',
  get url() {
    const version = getFeatureFlag(UnleashFlags.OOS_TRAINING_VERSION, 'release')
    return new URL(getOOSArtifactUrl('training-extension', version))
  },
  prerequisites: {
    [PrerequisiteRuleTypes.ENTITLEMENTS]: 'g2t',
    [PrerequisiteRuleTypes.ACCOUNT_SETTINGS]: 'training.isTrainingGoToAppEnabled',
  },
  integrations: {
    get msTeams() {
      return createMsTeamsIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
    },
  },
}

export default extensionConfig
